export default "__VITE_ASSET__374aaf9f__"